import script from "./BillingDetailEn.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingDetailEn.vue?vue&type=script&setup=true&lang=js"

import "./BillingDetailEn.vue?vue&type=style&index=0&id=d53100e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d53100e0"]])

export default __exports__